import { Pipe, PipeTransform } from '@angular/core';

// FIXME mettre en commun avec Colza

@Pipe({
  name: 'campaignStatus',
  standalone: true,
})
export class CampaignStatusPipe implements PipeTransform {
  // TODO mettre en commun avec les autres types de culture ?
  transform(item: any, attr: any): any {
    if (!item.configuration) {
      return 'Non configuré';
    } else {
      return 'Configuré';
    }
  }
}
